<template>
  <div class="full-screen" style="z-index: 10;background:#fff">
    <!-- <div class="header-nav">
      <div class="left">
        <a class="lk-back" @click="returnPage()">返回</a>
      </div>
    </div> -->
    <header class="aui-navBar aui-navBar-fixed b-line">
      <a @click="returnPage" class="aui-navBar-item">
        <i class="icon icon-return"></i>
      </a>
      <div class="aui-center">
        <span class="aui-center-title">绑定手机</span>
      </div>
      <a @click="returnHome" class="aui-navBar-item">
        <i class="icon icon-sys"></i>
      </a>
    </header>

     <section class="aui-scrollView no-foot">
      <p v-if="errorMsg.show" class="error-info">{{errorMsg.msg}}</p>
      <div class="login">
        <ul class="login-form">
          <li>
            <i class="ico-user"></i>
            <input type="text" v-model="mobile"   placeholder="请输入手机号码" />
          </li>
          <!-- <li>
            <i class="ico-password"></i>
            <input type="text" v-model="password" placeholder="请输入登录密码" />
          </li> -->
        </ul>
        <button type="button" @click="validate"  class="login-btn">绑定</button>
      </div>
    </section>
    <!-- <div class="login">
      <ul>
        <li>
          <label></label>
          <div><input v-model="mobile" class="inp" type="text" placeholder="请输入绑定手机号"/></div>
        </li>
        <li>
          <label>密码</label>
          <div><input v-model="pwd" class="inp" type="password" placeholder="请设置密码"/></div>
        </li>
        <li>
          <label>确认密码</label>
          <div><input v-model="confirmPwd" class="inp" type="password" placeholder="请确认密码"/></div>
        </li>
      </ul>

      <div v-if="errorMsg.show" class="text-red">{{errorMsg.msg}}</div>
      <div class="btnbox">
        <button type="button" class="btn" @click="validate">绑定</button>
      </div>
    </div> -->

    <div id="confirm-modal" v-if="showModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>{{changed ? '手机绑定成功' : resMsg}}</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="hideModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '../../../services/userService'

export default {
  name: 'mobile-bind',
  data () {
    return {
      mobile: '',
      pwd: '',
      confirmPwd: '',
      errorMsg: {
        show: false,
        msg: ''
      },
      changed: false,
      showModal: false,
      resMsg: ''
    }
  },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    validate () {
      //  else if (this.pwd === '') {
      //   this.errorMsg = { show: true, msg: '请输入密码' }
      // } else if (this.confirmPwd === '') {
      //   this.errorMsg = { show: true, msg: '请确认密码' }
      // } else if (this.pwd !== this.confirmPwd) {
      //   this.errorMsg = { show: true, msg: '密码不一致，请确认' }
      // }
      const reg = /^1[0-9]{10}$/
      if (this.mobile === '') {
        this.errorMsg = { show: true, msg: '请输入手机号' }
      } else if (!reg.test(this.mobile)) {
        this.errorMsg = { show: true, msg: '请输入正确的手机号' }
      } else {
        this.errorMsg = { show: false, msg: '' }
        this.bindMobile()
      }
    },
    bindMobile () {
      userService.bindMobile(this.mobile)
        .then(res => {
          if (res.result) {
            userService.updateUserInfo()
            this.changed = true
            this.showModal = true
          } else {
            this.changed = false
            this.showModal = true
            this.resMsg = res.msg
          }
        })
    },
    hideModal () {
      const obj = document.getElementById('confirm-modal')
      obj.style.opacity = 1
      this.slideOut(obj)
    },
    slideOut (obj) {
      obj.style.opacity -= 0.05
      if (obj.style.opacity > 0) {
        setTimeout(() => {
          this.slideOut(obj)
        }, 15)
      } else {
        this.showModal = false
        this.$router.isBack = true
        this.$router.go(-1)
      }
    }
  },
  mounted () {
    this.$router.isBack = true
  }
}
</script>

<style scoped>

</style>
